import { ElementTypes } from '@bynder-studio/render-core';

export enum DesignTab {
    SCENE = 'SCENE',
    VARIATIONS = 'VARIATIONS',
    AUDIO = 'AUDIO',
}

export type ShotElementType = Lowercase<ElementTypes>;
